module.exports = __webpack_public_path__ + "img/u231.65a5e119.svg";